import {GROUP_TYPE, ITEM_TYPE, CURSOR, getTextColor, GROUP_SECTION_WIDTH, drawBorderLines, getTrimmedText /*, createCacheCanvas*/} from '../../canvas-timeline/canvas_timeline_util';
import Group from '../../canvas-timeline/canvas_timeline_group';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import {interactionManager} from '../../canvas-timeline/canvas_timeline_interaction_manager';
import {PROJECT_STATUS} from '../../../../constants';
import Util from '../../../../forecast-app/shared/util/util';
import {hasPermission} from '../../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../../Permissions';
import {drawExpansionImageIcon} from '../../canvas-timeline/canvas_timeline_icon_util';

class UnassignedRoleGroup extends Group {
	constructor(data) {
		super(GROUP_TYPE.PEOPLE_SCHEDULING_UNASSIGNED_ROLE, data);
	}

	draw(canvasContext, x, y, collapsableSectionHeight) {
		const width = GROUP_SECTION_WIDTH;
		const {data, height, expanded, groupType} = this;
		super.draw(x, y, width, height, this, collapsableSectionHeight);
		const {id, name, projects, roleId, viewer, projectPersons, getItems} = data;
		const items = getItems();
		const tasks = items.filter(item => item.itemType === ITEM_TYPE.PEOPLE_SCHEDULING_TASK && !item.filtered).map(item => item.data.task);
		const taskCount = tasks.filter(
			task =>
				task.startDay &&
				task.deadlineDay &&
				!task.done &&
				task.assignedPersons.length === 0 &&
				(task.roleId || null) === roleId &&
				![PROJECT_STATUS.HALTED, PROJECT_STATUS.DONE].includes(projects.find(project => project.id === task.projectId).status) &&
				(hasPermission(PERMISSION_TYPE.PROJECTS_READ_ALL) || projectPersons.find(projectPerson => projectPerson.personId === viewer.actualPersonId && projectPerson.projectId === task.projectId))
		).length;

		const textColor = getTextColor();

		canvasContext.fillStyle = textColor;
		canvasContext.font = '500 12px ' + Util.getFontFamily();
		const taskCountTextWidth = canvasContext.measureText(taskCount).width;
		canvasContext.fillText(taskCount, x + (84 - taskCountTextWidth) / 2, y + 28);

		const cacheId = `${groupType}-${id}-${!!expanded}`;
		interactionManager.addCursorStyleArea(x, y, width, height, CURSOR.POINTER, true);

		const cachedData = cacheManager.get(groupType, cacheId);
		if (cachedData) {
			canvasContext.drawImage(cachedData, x, y, width, this.itemRowHeight);
			return;
		}

		/*const drawCacheablePart = () => {
			const cacheCanvas = createCacheCanvas(width, this.itemRowHeight);
			const context = cacheCanvas.getContext('2d');
			drawBorderLines(context, 0, 0, width, height, true);
			drawExpansionIcon(context, 0, 0, width, this.itemRowHeight, {
				expanded
			});
			context.fillStyle = textColor;
			context.font = 'normal 12px ' + Util.getFontFamily();
			context.fillText(getTrimmedText(context, name), 58, 28);
			cacheManager.set(groupType, cacheId, cacheCanvas);
			canvasContext.drawImage(cacheCanvas, x, y, width, this.itemRowHeight);
		};
		drawCacheablePart();*/

		drawBorderLines(canvasContext, x, y, width, height, true);
		drawExpansionImageIcon(canvasContext, x, y, width, this.itemRowHeight, {
			expanded,
			align: 'left',
		});
		canvasContext.fillStyle = textColor;
		canvasContext.font = 'normal 12px ' + Util.getFontFamily();
		canvasContext.fillText(getTrimmedText(canvasContext, name), x + 60, y + 28);
	}
}

export default UnassignedRoleGroup;
